import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Chain = forwardRef<SVGSVGElement, SvgIconProps>(
  function Chain(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M7.18 14.1a5.96 5.96 0 01.4-3.44L6.42 9.54a2.22 2.22 0 010-3.18 2.33 2.33 0 013.25 0l3.9 3.82a2.22 2.22 0 010 3.18c-.32.3-.7.5-1.1.6l2.1 2.04c.33-.2.65-.44.94-.73a4.89 4.89 0 000-7l-3.9-3.82a5.13 5.13 0 00-7.14 0 4.89 4.89 0 000 7l2.7 2.65zm10.64-3.2a5.95 5.95 0 01-.4 3.44l1.15 1.12a2.22 2.22 0 010 3.18 2.33 2.33 0 01-3.25 0l-3.9-3.82a2.22 2.22 0 010-3.18c.32-.3.7-.5 1.09-.6L10.42 9c-.33.2-.65.44-.94.73a4.89 4.89 0 000 7l3.9 3.82a5.13 5.13 0 007.14 0 4.89 4.89 0 000-7l-2.7-2.65z" />
      </SvgIcon>
    )
  },
)

export default Chain
